import { DSNoteInput } from "@components/design-system/organisms/DSNoteInput";
import { usePlainNoteEditor } from "@hooks";
import React, { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { TEMPLATE_TYPES } from "../../../constants";

// Map RHF templateField fieldNames to DSNoteInput data keys
const FIELD_TO_DATA_KEY = {
  SUBJECTIVE: "subjective",
  OBJECTIVE: "objective",
  ASSESSMENT: "assessment",
  PLAN: "plan",
  CUSTOM: "content",
};

const SOAP_SECTIONS = [
  "subjective",
  "objective",
  "assessment",
  "plan",
];

const TemplateFields = ({ control, readOnly = false }) => {
  const { setValue } = useFormContext();
  const usePlainEditor = usePlainNoteEditor();
  const templateFields = useWatch({
    control,
    name: "templateFields",
  });
  const templateType = useWatch({ control, name: "templateType" });

  const isSoap = templateType === TEMPLATE_TYPES.SOAP;
  const sections = isSoap ? SOAP_SECTIONS : ["freeform"];

  // Convert RHF templateFields array → NoteDisplayData object
  const noteData = useMemo(() => {
    const data = {};
    templateFields.forEach((field) => {
      const key = FIELD_TO_DATA_KEY[field.fieldName];
      if (key) {
        data[key] = field.fieldValue || "";
      }
    });
    return data;
  }, [templateFields]);

  // Sync DSNoteInput changes back to RHF
  const handleNoteChange = (newData) => {
    templateFields.forEach((field, index) => {
      const key = FIELD_TO_DATA_KEY[field.fieldName];
      if (!key) return;
      const newValue = newData[key] || "";
      if (newValue !== field.fieldValue) {
        setValue(`templateFields.${index}.fieldValue`, newValue, {
          shouldDirty: true,
        });
      }
    });
  };

  return (
    <DSNoteInput
      dataTestId="template-fields"
      data={noteData}
      onChange={handleNoteChange}
      disabled={readOnly}
      showPlaceholderAlways
      plainText={usePlainEditor}
    >
      {sections.map((section) => (
        <div key={section} data-hint-field={section}>
          <DSNoteInput.NoteField
            section={section}
            showCopyButton={false}
          />
        </div>
      ))}
    </DSNoteInput>
  );
};

export default TemplateFields;
